export default __webpack_public_path__ + "static/media/telegram-24.bafc6b47.svg";